import React from 'react'
import { Checkbox } from 'antd'
import { isEmpty } from 'lodash'
import { Field, Row, Col } from '../../styles'
import {
  Organization,
  Groups,
  Group
} from '../../styles/blocks/orgGroupSelector'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

function GroupPicker(props) {
  const handleChange = (id, orgId) => {
    const { onChange } = props

    if (onChange) {
      onChange(id, orgId)
    }
  }

  const handleSelectAll = organizationId => {
    const { onChangeAll } = props

    if (onChangeAll) {
      onChangeAll(organizationId)
    }
  }

  const { selectedGroups = [], activeOrgId } = props

  const orgList = useSelector(state => state.organizations.list.rows)
  const user = useSelector(state => state.user)
  const { t } = useTranslation()

  const { isSuperAdmin } = user.info

  const list =
    !isEmpty(orgList) &&
    orgList
      .filter(i => isSuperAdmin || (i.role && i.role.name === 'Admin'))
      .filter(i => (i.groups || []).length)

  return (
    <Field>
      <Field.Label>{t('labels:select_organization')}</Field.Label>
      <div className="scorm-org main-org-group">
        <div className="org-group-row">
          {list &&
            list.map(organization => {
              const { groups = [], id, logo, title } = organization
              const selectedOrgGroups = groups.filter(i =>
                selectedGroups.includes(i.id)
              )
              const checkedOrganization =
                selectedOrgGroups.length === groups.length
              const indeterminateOrganizationsStatus =
                selectedOrgGroups.length &&
                selectedOrgGroups.length < groups.length

              const isDisabled = activeOrgId !== id
              return (
                <div className="org-group-list" key={id}>
                  <div
                    className={`org-group-btn`}
                    disabled={isDisabled}
                    onClick={() => handleSelectAll(id)}
                  >
                    <Organization.Checkbox>
                      <Checkbox
                        checked={checkedOrganization}
                        indeterminate={indeterminateOrganizationsStatus}
                      />
                    </Organization.Checkbox>

                    {logo ? (
                      <Organization.Image
                        src={logo ? logo.link : ''}
                        alt=""
                        className="org-image-user"
                      />
                    ) : (
                      <Organization.DefaultImage className="org-image-user">
                        {title.charAt(0).toUpperCase()}
                      </Organization.DefaultImage>
                    )}
                    <Organization.Name className="org-title">
                      {title}
                    </Organization.Name>
                  </div>
                  <Groups disabled={isDisabled}>
                    <Groups.List className="group-list">
                      {groups.map(group => (
                        <Groups.Item key={group.id} className="group-item">
                          <Group onClick={() => handleChange(group.id, id)}>
                            <Group.Checkbox>
                              <Checkbox
                                checked={selectedGroups.includes(group.id)}
                              />
                            </Group.Checkbox>
                            <Group.Name>{group.title}</Group.Name>
                          </Group>
                        </Groups.Item>
                      ))}
                    </Groups.List>
                  </Groups>
                </div>
              )
            })}
        </div>
      </div>
    </Field>
  )
}

export default GroupPicker
